import React from "react";
import { Routes, Route } from "react-router-dom";
import ScrollTop from "./layout/ScrollTop";
import Home from "./routes/Home";
import Services from "./routes/Services";
import Service from "./routes/Service";
import Outcomes from "./routes/Outcomes";
import Pulse from "./routes/Pulse";
import Studio from "./routes/Studio";
import Contact from "./routes/Contact";
import NotFound from "./routes/NotFound";

const App = () => (
  <ScrollTop>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<Service />} />
      <Route path="/outcomes" element={<Outcomes />} />
      <Route path="/pulse" element={<Pulse />} />
      <Route path="/studio" element={<Studio />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </ScrollTop>
);

export default App;
